import { render, staticRenderFns } from "./SalaryContact.vue?vue&type=template&id=f3850672&scoped=true"
import script from "./SalaryContact.vue?vue&type=script&lang=js"
export * from "./SalaryContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3850672",
  null
  
)

export default component.exports